module.exports = __webpack_public_path__ + "img/reason4.fbe561b5.png";